import { motion } from "framer-motion";

const partners = [
  {
    name: "Janain Al-Salsabeel",
    location: "Aqaba · Amman, Jordan",
    role: "Silent Partner · Industrial Supply, Engineering & Aviation Logistics",
    since: "Est. 2004",
    detail:
      "Twenty years of trading, engineering and airport logistics across Jordan and the wider MENA region — a One-Stop-Shop model for phosphate mines, refineries and infrastructure.",
    img: "https://images.pexels.com/photos/13806469/pexels-photo-13806469.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
  {
    name: "Beijing Petrochemical Engineering Co., Ltd.",
    location: "Beijing · Xi'an, China",
    role: "EPC Partner · Refining, Petrochemical, LNG & Coal Chemical",
    since: "Est. 1979",
    detail:
      "State-owned Class-A engineering house with 200+ EPC / PMC projects, joined by TIEC and YCPC. FEED, EPC, PMC and technology development from crude distillation to LNG plants.",
    img: "https://images.pexels.com/photos/1178683/pexels-photo-1178683.jpeg?auto=compress&cs=tinysrgb&w=1600",
  },
];

export default function Partners() {
  return (
    <section
      id="partners"
      className="relative py-32 md:py-40 border-t border-navy-border"
      data-testid="partners"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex items-end justify-between flex-wrap gap-6 mb-16 md:mb-20"
        >
          <div>
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-gold" />
              <span className="overline">Silent Partners</span>
            </div>
            <h2 className="h-display text-4xl md:text-6xl leading-[1.03] max-w-3xl">
              You engage Mends.<br />
              <span className="text-gold">You get decades of specialism.</span>
            </h2>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {partners.map((p, i) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="group relative border border-navy-border bg-navy-surface/60 overflow-hidden"
              data-testid={`partner-${i}`}
            >
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={p.img}
                  alt={p.name}
                  className="w-full h-full object-cover img-graded transition-transform duration-[1000ms] group-hover:scale-105"
                  draggable="false"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-surface via-navy-surface/40 to-transparent pointer-events-none" />
                <div className="absolute top-6 left-6 font-mono text-[10px] tracking-[0.3em] uppercase text-gold/90">
                  {p.since}
                </div>
              </div>
              <div className="p-8 md:p-10">
                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/50 mb-3">
                  {p.location}
                </div>
                <h3 className="h-display text-2xl md:text-3xl leading-[1.15] mb-4">{p.name}</h3>
                <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-gold/80 mb-6">
                  {p.role}
                </div>
                <p className="text-white/60 leading-[1.85] text-[14.5px]">{p.detail}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
